
import React from "react";
import ProductInfo from "./ProductInfo";
import { MdOutlineFileDownload } from "react-icons/md";
import { useTranslation } from 'react-i18next';

/* ---------------------------------------------------------------------------- */

import {
  DownloadButton,
  DownloadList,
  ProductDescription,
  ProductDocument,
  ProductImage,
  ProductSection,
} from "./StyledComponents";

/* ----------------------------------------------------------------------------
 *          IMAGES
 * --------------------------------------------------------------------------- */

import TryggVardagSurfplattaBild from "../../../../data/images/products/Trygg Vardag Surfplatta/Huvudbild_surfplatta.png";


/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES
 * --------------------------------------------------------------------------- */

import TryggVardagRekond from "../../../../data/downloads/Trygg_vardag_rekonditionering_nya.pdf";
import TryggVardagSurfplattaBordstativ from "../../../../data/downloads/Trygg-vardag-surfplatta-bordstativ.pdf";
import TryggVardagSurfplattaManual from "../../../../data/downloads/Manual_trygg-vardag_surfplatta_nya.pdf";
import TryggVardagSurfplattaStartaUpp from "../../../../data/downloads/Starta_upp_trygg-vardag_surfplattan_nya.pdf";
import TryggVardagSurfplattaSnabbGuide from "../../../../data/downloads/Snabbguide_trygg-vardag_surfplatta_nya.pdf";


/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES - OLD
 * --------------------------------------------------------------------------- */

import TryggVardagSurfplattaManual_gammal from "../../../../data/downloads/Manual-trygg-vardag-surfplatta.pdf";
import TryggVardagSurfplattaStartaUpp_gammal from "../../../../data/downloads/Starta-upp-trygg-vardag-surfplattan.pdf";
import TryggVardagSurfplattaSnabbGuide_gammal from "../../../../data/downloads/Trygg-vardag-surfplatta-snabbguide.pdf";

/* ============================================================================ */
/*          PORT | KOMM - function
/* ============================================================================ */


const TryggVardagSurfplatta = () => {
  
  const { t } = useTranslation("products/tryggvardagsurfplatta"); 

  return (
    <main className="product container">
      <ProductSection>
        <h1>{t('h1_tryggvardagsurfplatta')}</h1>
        <ProductImage src={TryggVardagSurfplattaBild} alt="" />

        <ProductDescription>
          <p>{t('p1_tryggvardagsurfplatta')}</p>
          <p>{t('p2_tryggvardagsurfplatta')}</p>
          <p>{t('p3_tryggvardagsurfplatta')}</p>
        </ProductDescription>
    
        <ProductInfo titel={t('dokument_tryggvardagsurfplatta')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardagsurfplatta')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagSurfplattaManual} download="manual-trygg-vardag-surfplatta.pdf">
                    <span>Användarmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                
                <DownloadButton>
                  <a href={TryggVardagSurfplattaStartaUpp} download="Starta-upp-trygg-vardag-surfplatta.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagSurfplattaSnabbGuide} download="Snabbguide-trygg.vardag-surfplatta.pdf">
                    <span>Snabbguide</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagSurfplattaBordstativ} download="Bord/Väggstativ-trygg.vardag-surfplatta.pdf">
                    <span>Bord/Väggstativ</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagRekond} download="manual-trygg-rekonditionering.pdf">
                    <span>Rekonditionersingsmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>

        <ProductInfo titel={t('dokument_tryggvardagsurfplatta_gammal')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardagsurfplatta')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagSurfplattaManual_gammal} download="manual-trygg-vardag-surfplatta-äldre-version.pdf">
                    <span>Användarmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                
                <DownloadButton>
                  <a href={TryggVardagSurfplattaStartaUpp_gammal} download="Starta-upp-trygg-vardag-surfplatta-äldre-version.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagSurfplattaSnabbGuide_gammal} download="Snabbguide-trygg.vardag-surfplatta-äldre-version.pdf">
                    <span>Snabbguide</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>
        
      </ProductSection>
    </main>
  );
};

export default TryggVardagSurfplatta;
